<!--
SPDX-FileCopyrightText: 2026 Nextcloud cookbook contributors

SPDX-License-Identifier: AGPL-3.0-only OR AGPL-3.0-or-later
-->

<template>
    <li :class="{ done: isDone }" @click="toggleDone">
        <VueShowdown :markdown="instruction" class="markdown-instruction" />
    </li>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
    /* Instruction HTML string to display. Content should be sanitized.
     */
    instruction: {
        type: String,
        default: '',
    },
});

/**
 * @type {import('vue').Ref<boolean>}
 */
const isDone = ref(false);

const toggleDone = () => {
    isDone.value = !isDone.value;
};
</script>

<script>
export default {
    name: 'RecipeInstruction',
};
</script>

<style scoped>
li {
    position: relative;
    margin-bottom: 2rem;
    clear: both;
    counter-increment: instruction-counter;
    cursor: pointer;
    padding-inline-start: calc(36px + 1rem);
    white-space: pre-line;
}

li::before {
    position: absolute;
    top: 0;
    width: 36px;
    height: 36px;
    border: 1px solid var(--color-border-dark);
    border-radius: 50%;
    background-color: var(--color-background-dark);
    background-position: center;
    background-repeat: no-repeat;
    content: counter(instruction-counter);
    inset-inline-start: 0;
    line-height: 36px;
    outline: none;
    text-align: center;
}

li:hover::before {
    border-color: var(--color-primary-element);
}

.done::before {
    content: '✔';
}

li span,
li input[type='checkbox'] {
    display: inline-block;
    width: 1rem;
    height: auto;
    padding: 0;
    margin: 0 0.5rem 0 0;
    line-height: 1rem;
    vertical-align: middle;
}

.markdown-instruction:deep(ol > li) {
    list-style-type: numbered;
}

.markdown-instruction:deep(ul > li) {
    list-style-type: disc;
}

.markdown-instruction:deep(ol > li),
.markdown-instruction:deep(ul > li) {
    margin-inline-start: 20px;
}

.markdown-instruction:deep(a) {
    text-decoration: underline;
}
</style>
